import { Component, OnInit, inject } from '@angular/core'
import { DialogRef } from './dialog-ref'
import { DIALOG_DATA } from './dialog.service'
import { IconValuesType } from '../icon/icon.component.types'

/**
 * Defines the dialog options.
 */
export interface DialogOptions {
  headerText?: string
  headerIcon?: IconValuesType
  primaryButtonText?: string
  secondaryButtonText?: string
}

/**
 * Abstract base dialog component with generics.
 * @template T - Type of incoming dialog data.
 * @template R - Type of return value when dialog closes.
 */
@Component({ template: '' })
export abstract class BaseDialogComponent<
  T = unknown,
  R = void,
> implements OnInit {
  protected dialogRef = inject<DialogRef<R>>(DialogRef)
  protected data = inject<T>(DIALOG_DATA) // Angular 16+ auto-infers the type
  protected options: DialogOptions = {}

  ngOnInit(): void {
    this.initializeOptions()
  }

  /**
   * Override this method in child classes to set dialog options.
   */
  protected abstract initializeOptions(): void

  /**
   * Call this from child classes when primary action is performed.
   */
  protected onPrimaryAction(result?: R): void {
    this.dialogRef.close(result)
  }

  /**
   * Call this from child classes when secondary action is performed.
   */
  protected onSecondaryAction(): void {
    this.dialogRef.close()
  }
}
